// extracted by mini-css-extract-plugin
export var cartIcon = "_ox-0";
export var cartIconContainer = "_ox-1";